import Btn from './button'
import RegisterSuccess from './register-success'
import ChildItem from './child-item'
import Tabbar from './tabbars'
import TabbarCartoon from './tabbars/cartoon'
import AlertPopup from './alert-popup'
import ModelChoice from './model-choice'
import Scroll from './scroll'
import NullData from './null-data'
import PDF from './pdf'

export default {
  install: Vue => {
    Vue.component('Btn', Btn)
    Vue.component('RegisterSuccess', RegisterSuccess)
    Vue.component('ChildItem', ChildItem)
    Vue.component('Tabbar', Tabbar)
    Vue.component('TabbarCartoon', TabbarCartoon)
    Vue.component('AlertPopup', AlertPopup)
    Vue.component('ModelChoice', ModelChoice)
    Vue.component('Scroll', Scroll)
    Vue.component('NullData', NullData)
    Vue.component('PDF', PDF)
  }
}
